import { call, put } from 'redux-saga/effects'

import { fetchApi } from '../helpers/fetchApi'

import { isValidSku } from '../../helpers/skuValidator'

import {
  fetchEssentialExtrasSuccess,
  fetchExtraDataRequest,
  fetchEssentialExtrasFailure
} from '../../actionCreators/essentialExtras/essentialExtrasActionCreators'
import { isAppExclusiveSKU } from '@/javascript/helpers/appExclusiveSkusHelper'

const endpoint = '/recommendations-api?channel=pdp&placement=attach&itemId='

function* essentialExtrasSaga(action, baseUrl) {
  const { partNumber, postcode, storeId } = action.payload

  const postCodeParam = postcode ? `&postcode=${postcode}` : ''
  const storeIdParam = storeId ? `&storeId=${storeId}` : ''

  try {
    if (!isValidSku(partNumber)) {
      const error = new Error('Invalid part number')
      error.status = 400
      throw error
    }
    if (!isAppExclusiveSKU(partNumber)) {
      const url = `${baseUrl || ''}${endpoint}${partNumber}${postCodeParam}${storeIdParam}`
      const headers = { Accept: 'application/vnd.recommendations+json' }

      const jsonData = yield call(fetchApi, url, null, headers)
      const successAction = fetchEssentialExtrasSuccess(jsonData)
      yield put(successAction)
      yield put(fetchExtraDataRequest({ partNumber: jsonData.data[0].id, mainProductPartNumber: partNumber }))
    }
  } catch (error) {
    const failureAction = fetchEssentialExtrasFailure({ errorDetail: error?.toString() })
    yield put(failureAction)
  }
}

export { essentialExtrasSaga, endpoint }
